export enum Mediums {
  ADSL = 0,
  TdLte = 30,
  FdLte = 31,
  NGN = 40,
  SubscriptionPackage = 41,
}
